module.exports = "<p>\n  car works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/car/car.component.html
// module id = 157
// module chunks = 1